import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'redux-little-router';
import { CSVLink } from 'react-csv';
import {
  Avatar,
  Input,
  Layout,
  Select,
  Card,
  Button,
  Divider,
  Row,
  Col,
  Icon,
  Tag,
  Table,
  Dropdown,
  Tooltip,
} from 'antd';
import TabContentHeader from '../TabContentHeader';
import { setSearch } from '../../common/reducers/categoryCollectionReducer';
import _ from 'lodash';

const addEllipsis = (width) => ({
  width: width + 'px',
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const compareItems = (a, b, prop = 'name') => {
  const valA = _.get(a, prop, '');
  const valB = _.get(b, prop, '');
  return valA.localeCompare(valB);
};

const columns = [
  {
    key: 'published',
    title: '',
    dataIndex: 'published',
    render: published => (
      <>
        {published ? (<Tooltip title="This category is published so will be applied to new media" ><Avatar
          size="small"
          icon="check"
          shape="square"
          style={{ background: '#8ed752' }}
        /></Tooltip>) : (<Tooltip title="This category is NOT published so will NOT be applied to new media" ><Avatar
          size="small"
          icon="close"
          shape="square"
          style={{ background: '#c3c3c3' }}
        /></Tooltip>)}
      </>
    ),
    fixed: 'left',
    width: 32,
  },
  {
  key: 'name',
  title: 'Name',
  dataIndex: 'id',
  render: text => (
    <span>
      <Link style={addEllipsis(180)} replaceState href={`/tab?type=category&recordId=${encodeURIComponent(text)}`}>{text}</Link>
    </span>
  ),
  fixed: 'left',
  width: 180,
  sorter: (a, b) => compareItems(a, b, 'name'),
}, {
  key: 'version',
  title: 'Version',
  dataIndex: 'version',
  render: version => <span><div style={addEllipsis(100)}>{version && <Tag color="blue">{version}</Tag>}</div></span>,
  width: 100,
  sorter: (a, b) => compareItems(a, b, 'version'),
}, {
  key: 'tags',
  title: 'Tags',
  dataIndex: 'tags',
  render: tags => <span><div style={addEllipsis(300)}>{tags.map(tag => <Tag key={tag}>{tag}</Tag>)}</div></span>,
  width: 300,
  sorter: (a, b) => compareItems(a, b, 'tags[0]'),
}, {
  key: 'description',
  title: 'Description',
  dataIndex: 'description',
  width: 400,
  render: description => <span><div style={addEllipsis(400)}>{description}</div></span>,
  sorter: (a, b) => compareItems(a, b, 'description'),
}, {
  key: 'created',
  title: 'Created',
  dataIndex: 'created',
  width: 180,
  sorter: (a, b) => compareItems(a, b, 'created'),
}, {
  key: 'lastModified',
  title: 'Last Modified',
  dataIndex: 'lastModified',
  width: 180,
  sorter: (a, b) => compareItems(a, b, 'lastModified'),
}];

const mapStateToProps = state => ({
  categoryCollection: state.categoryCollection,
});

const prepCategoryForCsv = x => ({
  ...(_.omit(x, 'id')),
  query: x.query.replace(/"/g, '""'),
  tags: x.tags.join(', '),
  published: x.published ? 'true': 'false',
});

function getFileName() {
  const dateName = new Date().toISOString().slice(0,10);
  return `Categories_${dateName}.csv`;
}

const Browse = ({ categoryCollection, setSearch }) => {

  const { collection, __loading, search } = categoryCollection

  const onChange = e => {
    const search = e.target.value;
    setSearch(search);
  };

  return (
  <div>
    <TabContentHeader
      title="Browse"
      icon="folder"
    />
    <div style={{ padding: '32px' }}>
      <Row type="flex" style={{ background: '#fff', padding: '16px', justifyContent: 'space-between' }}>
        <Col>
          <Select
            defaultValue="Categories"
            style={{ width: 200 }}
          >
            <Select.Option value="categories">Categories</Select.Option>
          </Select>
        </Col>
        <Col style={{ marginLeft: '16px', alignSelf: 'center' }}>
          <Input.Search style={{ width: 200 }} onChange={onChange} placeholder="Search categories" />
          <Tooltip title={'Export to CSV'}>
            <CSVLink
              data={collection.map(prepCategoryForCsv)}
              filename={getFileName()}
              enclosingCharacter={`'`}
              className="btn btn-primary"
              target="_blank"
            >
              <Button size="small" icon="export" style={{ marginLeft: '10px'}} />
            </CSVLink>
          </Tooltip>
        </Col>
      </Row>
      <Table
        style={{ background: '#fff' }}
        columns={columns}
        loading={__loading}
        scroll={{ x: columns.reduce((sum, column) => sum + column.width, 0) }}
        dataSource={collection
          .map((category, i) => ({ ...category, key: i }))
          .filter(x => !search || [x.name, x.tags.join(', '), x.query].join(' ').toLowerCase().indexOf(search.toLowerCase()) > -1)
        }
      />
    </div>
  </div>
)
};

export default connect(mapStateToProps, { setSearch })(Browse);

/*
  {
    key: 'published',
    title: '',
    dataIndex: 'published',
    render: published => (published === 'active' ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>),
    fixed: 'left',
    width: 80,
  }
*/
